import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';

import {SERVER_API_URL} from '@app/app.constants';
import {IPasswordChange} from '@shared/model/password-change';

export interface AccountDTO {
  id?: number;
  login?: string;
  email?: string;
  authorities?: string[];
}
@Injectable({providedIn: 'root'})
export class AccountService {
  constructor(private http: HttpClient) {}

  get(): Observable<HttpResponse<AccountDTO>> {
    return this.http.get<AccountDTO>(SERVER_API_URL + 'api/account', {
      observe: 'response',
    });
  }

  save(account: any): Observable<HttpResponse<any>> {
    return this.http.post(SERVER_API_URL + 'api/account', account, {
      observe: 'response',
    });
  }

  changePassword(passwordChange: IPasswordChange) {
    return this.http.post(
      SERVER_API_URL + 'api/account/change-password',
      passwordChange,
      {observe: 'response'},
    );
  }
}
